import { useTranslation } from 'react-i18next';

export const useObjectSearchBy = () => {
  const { t } = useTranslation();

  const objectSearchBy = [
    { value: 'propertyName', label: t('Term'), placeholder: 'Search...' },
    { value: 'propertyCode', label: t('Code'), placeholder: 'Search...' },
  ];

  return { objectSearchBy };
};
